import { render, staticRenderFns } from "./home-top-banner.vue?vue&type=template&id=2b124b08"
import script from "./home-top-banner.vue?vue&type=script&lang=js"
export * from "./home-top-banner.vue?vue&type=script&lang=js"
import style0 from "./home-top-banner.vue?vue&type=style&index=0&id=2b124b08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports